import { HttpErrorsType } from '../../application/protocols/http-client';
import { type DomainException } from './domain-exception';

export class InvalidCredentialsException implements DomainException {
  message = 'Credenciais Inválidas'; // TODO translate it.
  code = HttpErrorsType.INVALID_CREDENTIALS_EXCEPTION;
}
